export default __webpack_public_path__ + "static/media/Roboto-Medium.e2d3fd03.woff";